import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import ApplicationRedirector from "./ApplicationRedirector";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import { Paper, Typography } from "@mui/material";
import { SearchBar } from "src/chamber/features/dashboard/ui/SearchBar";
import { useState } from "react";

type TChangeApplicationsProps = {
  activeOwnOnlyApplications: number | null;
  activeOwnApplications: number | null;
  activeOwnCertificateApplicationsCount: number | null;
  activeChamberApplicationsPaidCount: number | null;
  activeChamberApplicationsUnpaidCount: number | null;
  isOrgAdmin: boolean;
  legalTypes: { d08_id: number; d08_descr: string }[];
  appTypes: { label: string; value: number }[];
  chamberUsers: { label: string; value: number }[];
  responsibleNow: { label: string; value: number }[];
  statuses: { label: string; value: number }[];
  unsignedOwnCertificateApplicationsCount: number | null;
  countsLoading?: boolean;
};

function ChangeApplications(props: TChangeApplicationsProps) {
  const { t } = useTranslation();
  const [protocol, setProtocol] = useState("");
  const [gemi, setGemi] = useState("");
  return (
    <Paper sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Typography
          variant="h5"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <ChecklistOutlinedIcon />
          {t("Αιτήσεις Καταχώρισης Μεταβολών")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <SearchBar
          mode={"application"}
          protocol={protocol}
          gemi={gemi}
          setProtocol={setProtocol}
          setGemi={setGemi}
        />
      </Box>

      <ApplicationRedirector
        countsLoading={props.countsLoading}
        activeOwnOnlyApplicationsCount={props.activeOwnOnlyApplications}
        activeChamberApplicationsPaidCount={
          props.activeChamberApplicationsPaidCount
        }
        activeChamberApplicationsUnpaidCount={
          props.activeChamberApplicationsUnpaidCount
        }
        activeOwnApplications={props.activeOwnApplications}
        unsignedOwnCertificateApplicationsCount={
          props.unsignedOwnCertificateApplicationsCount
        }
        isOrgAdmin={props.isOrgAdmin}
        responsibleNow={props.responsibleNow}
        legalTypes={props.legalTypes}
        appTypes={props.appTypes}
        statuses={props.statuses}
        chamberUsers={props.chamberUsers}
        useForCertificate={false}
      />
    </Paper>
  );
}

export default ChangeApplications;
